import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import api from "@src/common/services/api.service"
import AppConstants from "@src/utils/app.constants"
import { ApplicationResponse } from "@src/common/domain/common.model"
import { CategoryStore, NewCategoryModelRef } from "../components/domain/category.model"
// import { NewProductModelRef, ProductStore } from "../domain/product.model"

export const addCategoryList = createAsyncThunk<void, any>("category/addCategory",
 async (payload: any) => {

    const response = await api.post<ApplicationResponse<NewCategoryModelRef[]>>(`${AppConstants.api}/category/create`, payload)
})
export const updateCategoryList = createAsyncThunk<void, any>("category/updateCategory",
 async (payload: any) => {
    const response = await api.put<ApplicationResponse<NewCategoryModelRef[]>>(`${AppConstants.api}/category/update`, payload)
})
export const fetchCategoryList = createAsyncThunk<any[], void> ("category/fetchCategory",
    async () => {
        const response = await api.get<ApplicationResponse<NewCategoryModelRef[]>>(`${AppConstants.api}/category/list`)
        return response.data.data || []   
    })
   export const deleteCategory = createAsyncThunk(
  "category/deleteCategory",
  async (id: string) => {
    try {
      const response = await api.delete<ApplicationResponse<any[]>>(
        `${AppConstants.api}/category/delete?id=${id}`
      );
      return response.data.data || [];
    } catch (err) {
      return [];
    }
  }
);
const CategorySlice = createSlice({
    name: "category",
    initialState: {minimal: {status: "loading", error: null, data: []}} as CategoryStore,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategoryList.pending, (state, action) => {
                state.minimal = {
                    status: "loading",
                    data: [],
                    error: null
                }
            })
            .addCase(fetchCategoryList.fulfilled, (state, action) => {
                state.minimal = {
                    status: "idle",
                    data: action.payload,
                    error: null
                }
            })
            .addCase(fetchCategoryList.rejected, (state, action) => {
                state.minimal = {
                    status: "failed",
                    data: [],
                    error: action.error
                }
            })

    }
})

export default CategorySlice.reducer
